import './image-teaser.css';

interface ImageTeaserProps {
    text: string;
    headline: string;
    image: string;
    link: string;
    objectfit: boolean;
}

const ImageTeaser = (props: ImageTeaserProps) => {

    return <div className={props.objectfit ? "image-teaser-container image-teaser-container-object-fit" : "image-teaser-container"}>
        <a className="image-teaser" href={props.link}>
            {/* <div className="image-teaser__wrapper">
                <h2 className="image-teaser__headline image-teaser__headline--hidden">
                    Innovation
                </h2>
            </div> */}
            <div className="image-teaser__image ">
                <picture>
                    <img className="" src={props.image} alt="Temporarily not available." />
                </picture>
            </div>
            <h3 className="image-teaser__headline ">
                {props.headline}
            </h3>
            <div className="image-teaser__text">
                <p className="image-teaser__text--paragraph">
                    {props.text}
                </p>
            </div>
        </a>
    </div >
}

export default ImageTeaser;
